import { IZipCodeInformationBaseViewModel } from 'viewModels';
import api from '../services/api/axios';

const getZipCodeWithGeoLocation = (zipCode: string) =>
  new Promise<IZipCodeInformationBaseViewModel>((resolve) => {
    api
      .post(`informationbasezipcode`, { cep: zipCode })
      .then(({ data }) => resolve(data))
      .catch();
  });

const InformationBaseZipCodeController = { getZipCodeWithGeoLocation };

export default InformationBaseZipCodeController;
